export default __webpack_public_path__ + "static/media/failed.6a0318f2.svg";